import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CustomNavbar from './components/CustomNavbar';

import FloatingButton from './components/FloatingButton';
import Footer from './components/Footer';
import Home from './pages/Home';
import  ExclusiveListings  from './pages/ExclusiveListings';
import  FeaturedLeases  from './pages/FeaturedLeases';
import  SoldListings  from './pages/SoldListings';
import  GlobalCollective  from './pages/GlobalCollective';
import { Contact } from './components/Contact';
import AboutInfo from './pages/AboutInfo';

function App() {
  return (
    <Router>
    <div className="App">
      <CustomNavbar/>
      <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/exclusiveListings" element={<ExclusiveListings />} />
          <Route path="/featuredLeases" element={<FeaturedLeases />} />
          <Route path="/soldListings" element={<SoldListings />} />
          <Route path="/globalCollective" element={<GlobalCollective />} />
          <Route path="/aboutInfo" element={<AboutInfo />} />
        </Routes>
      <Contact/>
      <Footer/>
      <FloatingButton/>
    </div>
    </Router>
  );
}

export default App;
